import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { MessageCircle, Code, FileSearch, FileText, ArrowRight, Sparkles } from 'lucide-react';
import { agentsList } from '../data/agents';

const iconMap = {
  MessageCircle,
  Code,
  FileSearch,
  FileText
};

const Solutions = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[var(--bg-primary)] pt-20 pb-16">
      <div className="container">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-[var(--accent-subtle)] border border-[rgba(37,99,235,0.2)] rounded-full mb-5">
            <Sparkles size={14} className="text-[var(--accent-primary)]" />
            <span className="text-sm font-medium text-[var(--accent-primary)]">AI-POWERED SOLUTIONS</span>
          </div>
          <h1 className="text-3xl md:text-4xl font-bold mb-4">
            Intelligent Agents for<br />
            <span className="gradient-text">Engineering Excellence</span>
          </h1>
          <p className="text-base text-[var(--text-secondary)] max-w-xl mx-auto">
            Experience our AI-enabled engineering capabilities firsthand. These agents demonstrate 
            how we accelerate software development and consulting processes.
          </p>
        </div>

        {/* Agent Cards Grid */}
        <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {agentsList.map((agent) => {
            const IconComponent = iconMap[agent.icon];
            return (
              <Link
                key={agent.id}
                to={`/solutions/${agent.id}`}
                className="group bg-[var(--bg-primary)] border border-[var(--border-subtle)] rounded-xl p-6 transition-all duration-300 hover:border-[var(--border-medium)] hover:shadow-lg hover:-translate-y-1"
              >
                <div className="flex items-start gap-4">
                  <div 
                    className="w-12 h-12 rounded-lg flex items-center justify-center transition-colors"
                    style={{ 
                      backgroundColor: `${agent.color}15`
                    }}
                  >
                    <IconComponent size={24} style={{ color: agent.color }} />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-lg font-semibold mb-1 group-hover:text-[var(--accent-primary)] transition-colors">
                      {agent.name}
                    </h3>
                    <p className="text-[var(--text-muted)] text-sm leading-relaxed mb-3">
                      {agent.description}
                    </p>
                    <div className="flex items-center gap-2 text-[var(--accent-primary)] text-sm font-medium">
                      <span>Try it now</span>
                      <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
                    </div>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-12 p-6 border border-[var(--border-subtle)] bg-[var(--bg-secondary)] rounded-xl max-w-2xl mx-auto">
          <h3 className="text-lg font-semibold mb-2">Want Custom AI Solutions?</h3>
          <p className="text-[var(--text-muted)] text-sm mb-4">
            These demos showcase our AI capabilities. We build custom AI agents tailored to your 
            specific workflows, tools, and domain requirements.
          </p>
          <Link 
            to="/#contact" 
            className="btn-primary inline-flex"
            onClick={(e) => {
              e.preventDefault();
              window.location.href = '/#contact';
            }}
          >
            Discuss Your AI Project
            <ArrowRight size={18} />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Solutions;
